import HeaderFlexContent from './versions/0.0.1';

export default HeaderFlexContent;
